import React, {useMemo} from 'react';
import {ListItem} from '@mui/material';
import ResponsiveTypography from '@/components/ui/responsive-typography';
import {MatrixEvent} from 'matrix-js-sdk/lib/models/event';
import EventItem from './event-item';
import {groupAndSortMatrixEventsByTime} from '@/components/matrix-chat/utils/helper-functions';

interface DateGroupItemProps {
  dateLabel: string;
  dateGroup: MatrixEvent[];
  memberId: string;
  numUnreadEventInList: number;
  lastReadEventInList: string | null;
}

const DateGroupItem: React.FC<DateGroupItemProps> = ({
  dateLabel,
  dateGroup,
  memberId,
  numUnreadEventInList,
  lastReadEventInList
}) => {
  const timeGroupedEvents = groupAndSortMatrixEventsByTime(dateGroup);

  const renderTimeGroups = useMemo(() => {
    return Object.entries(timeGroupedEvents).map(([timeLabel, timeGroup]) => {
      const isImageGroup = timeLabel.includes('-image');
      const isVideoGroup = timeLabel.includes('-video');

      return timeGroup.map((event, eventIdx) => (
        <EventItem
          key={event.getEffectiveEvent().event_id}
          event={event}
          memberId={memberId}
          eventIdx={eventIdx}
          timeGroup={timeGroup}
          lastReadEventInList={lastReadEventInList}
          numUnreadEventInList={numUnreadEventInList}
          isImageGroup={isImageGroup}
          isVideoGroup={isVideoGroup}
        />
      ));
    });
  }, [timeGroupedEvents, memberId, lastReadEventInList, numUnreadEventInList]);

  return (
    <React.Fragment>
      <ListItem
        sx={{
          marginTop: 2
        }}
      >
        <ResponsiveTypography sx={{fontWeight: 'bold'}}>
          {dateLabel}
        </ResponsiveTypography>
      </ListItem>

      {renderTimeGroups}
    </React.Fragment>
  );
};

export default DateGroupItem;
